import { Banner } from "../domain/banner";
import { getAllBannersService } from "../infrastructure/services/getAllBannersService";
import { tokenValidation } from "@/business/auth/application/tokenValidation";

export const getAllBanners = {
    async execute(): Promise<Banner[]> {
        return await getAllBannersService.execute(await tokenValidation.execute());
    },
};
